import React, { useCallback } from "react";
import styled from "styled-components/native";
import { Pressable } from "react-native";
import { SearchGridAdContainerProps } from "./types";
import { useTheme } from "styled-components/native";
import { EventType } from "@utils/analytics";
import { useUserAnalytics } from "../../../hooks/useAnalytics";
import { BannerActionEnum } from "../AdView/BannerAd/types";
import { createAdProps } from "../AdView/BannerAd/utils";
import { useSelector } from "react-redux";
import { Image as ExpoImage } from "expo-image";
import { useGlobalData } from "@redux/slices/globalSlice";
import { useRecyclingState } from "@shopify/flash-list";
import { parseAndNavigate } from "@utils/product/searchResultsNavigation";
import {
  getImageSource,
  getIOSImageProps,
  ImageSizePreset,
} from "@utils/image/imageOptimizer";

const SearchResultGridAdItem = ({ item }: SearchGridAdContainerProps) => {
  const theme = useTheme();
  const adHeight = useSelector((state: any) => state.appState.adHeight);
  const ImageComponent = ExpoImage;
  const { products } = useGlobalData();
  const [imageUri, setImageUri] = useRecyclingState(
    item?.media_url_url ? item?.media_url_url : "",
    [item?.id, item?.media_url_url],
    () => {}
  );
  const { trackAdEvent } = useUserAnalytics() as any;

  const handlePress = useCallback(async () => {
    if (item?.media_redirect_link_v2) {
      trackAdEvent(
        EventType.VIEW_BANNER,
        createAdProps(BannerActionEnum.clickThrough, item, {
          campaign: item.campaign,
        })
      );
      if (item?.media_redirect_link_v2) {
        await parseAndNavigate(item?.media_redirect_link_v2, products);
      }
    }
  }, [item?.media_redirect_link_v2]);

  return (
    <Pressable onPress={() => handlePress()}>
      <ParentContainer theme={theme} style={{ height: adHeight }}>
        {imageUri && (
          <ImageComponent
            contentFit="cover"
            source={getImageSource(imageUri, ImageSizePreset.AD_BANNER)}
            {...getIOSImageProps()}
            style={{
              width: "100%",
              flex: 1,
              borderRadius: 8,
            }}
            onError={() => {
              setImageUri("");
            }}
          />
        )}
      </ParentContainer>
    </Pressable>
  );
};

const ParentContainer = styled.View`
  width: 100%;
  border-radius: 8px;
  background-color: #ffffff;
`;

export default SearchResultGridAdItem;
